<div id="pause" fxLayoutAlign="center center">
  <div id="spinner"></div>
</div>
